import React, { useEffect } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';

interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
  action?: ToastAction;
}

export function Toast({
  message,
  onClose,
  duration = 2000,
  action
}: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 animate-slide-up">
      <div className="bg-[#5B8E87] text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-3">
        <CheckCircleIcon className="w-5 h-5" />
        <span className="font-medium">{message}</span>
        {action && (
          <button
            onClick={() => {
              action.onClick();
              onClose();
            }}
            className="px-3 py-1 bg-white/20 hover:bg-white/30 rounded-full text-sm font-semibold transition-colors"
          >
            {action.label}
          </button>
        )}
        <button onClick={onClose} className="ml-1">
          <XIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}